import { RedoMerchantClient } from "@redotech/redo-merchant-app-common/client";

export async function getInstagramIntegrations(
  client: RedoMerchantClient,
  { signal }: { signal?: AbortSignal } = {},
): Promise<any> {
  const response = await client.client.get("support/instagram", {
    headers: client.authorization(),
    signal,
  });
  return response.data;
}
